import React from 'react';
import { Star, User } from 'lucide-react';

// A helper function to render the star rating
const renderStars = (rating) => {
  return (
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, index) => (
        <Star
          key={index}
          size={16}
          className={
            index < rating
              ? 'text-yellow-500 fill-yellow-500'
              : 'text-neutral-300'
          }
        />
      ))}
    </div>
  );
};

const ReviewCard = ({ review }) => {
  const date = new Date(review.createdAt);
  const formattedDate = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="py-6 border-b border-neutral-200 dark:border-neutral-700">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-neutral-100 dark:bg-neutral-700 flex items-center justify-center overflow-hidden">
          {review.userPhotoURL ? (
            <img 
              src={review.userPhotoURL} 
              alt={review.userName} 
              className="w-full h-full object-cover" 
            />
          ) : (
            <User size={24} className="text-neutral-400 dark:text-neutral-500" />
          )}
        </div>
        <div>
          <h4 className="text-lg font-semibold text-neutral-800 dark:text-white">{review.userName}</h4>
          <p className="text-sm text-neutral-500 dark:text-neutral-400">{formattedDate}</p>
        </div>
        <div className="ml-auto">
          {renderStars(review.rating)}
        </div>
      </div>
      {review.comment && (
        <p className="text-neutral-600 dark:text-neutral-300 mt-4 leading-relaxed">
          {review.comment}
        </p>
      )}
    </div>
  );
};

export default ReviewCard;